import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Thankyou } = await import('./index');
    return {
        Component: Thankyou,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
